<template>
  <AisRefinementList
    v-slot="{ items, refine, canToggleShowMore, toggleShowMore, isShowingMore, searchForItems }"
    :attribute="filter.attributePath"
    :searchable="isSearchable"
    :sort-by="sortBy"
  >
    <div v-if="(!items || !items.length) && (!isSearchable || isSearchable && !searchQuery)" />
    <FilterDropdown v-else :label="filter.label">
      <template #selection>
        <div :class="{ 'group hide-labels': getSelectedItems(items).length > 2 }" class="flex gap-2">
          <div v-for="{ name, style } in getSelectedItems(items)" :key="name" class="flex gap-0.5 items-center">
            <div class="size-4 rounded-full" :style="style" />
            <div class="group-[.hide-labels]:hidden">
              {{ name }}
            </div>
          </div>
        </div>
      </template>
      <div>
        <div v-if="isSearchable" class="grid items-center mb-2">
          <input
            v-model="searchQuery"
            class="col-start-1 row-start-1 bg-grey-50 dark:bg-grey-100 focus-visible:border-grey-700 focus:outline-none focus-visible:bg-white dark:focus-visible:bg-grey-50 transition-colors border border-grey-50 rounded-full pl-10 pr-3 h-11 text-default placeholder:text-muted"
            type="search"
            :name="filter.urlParam+'-search'"
            :placeholder="filter.searchPlaceholderText || 'Etsi...'"
            @input="searchForItems(searchQuery)"
          >
          <MagnifyingGlassIcon class="size-5 text-secondary col-start-1 row-start-1 pointer-events-none ml-3" />
        </div>
        <div class="grid gap-1">
          <template v-for="item in items" :key="item.value">
            <FilterCheckbox
              :id="`${filter.urlParam}_${kebabCase(item.value)}`"
              :value="item.value"
              :name="filter.urlParam"
              :label="getName(item)"
              :checked="item.isRefined"
              :addition="item.count+''"
              @change="customRefine(refine, item.value)"
            >
              <template #checkmark>
                <div
                  class="size-6 rounded-full flex items-center justify-center group-has-[input:focus-visible]:ring-1 ring-grey-500 ring-offset-1"
                  :style="getStyle(item)"
                >
                  <CheckIcon class="size-5 hidden group-has-[input:checked]:block [filter:invert(1)_saturate(0)_brightness(2)_contrast(100)]" stroke-width="4" aria-hidden="true" />
                </div>
              </template>
            </FilterCheckbox>
          </template>
        </div>
        <button v-if="canToggleShowMore && !isShowingMore" class="text-red-900 py-2 px-4 mt-2" @click="toggleShowMore">
          Näytä lisää...
        </button>
      </div>
    </FilterDropdown>
  </AisRefinementList>
</template>

<script setup lang="ts">
// @ts-ignore
import kebabCase from 'lodash.kebabcase'
import { MagnifyingGlassIcon, CheckIcon } from '@heroicons/vue/24/outline'
import FilterCheckbox from '~/components/category/product-filters/FilterCheckbox.vue'
import FilterDropdown from '~/components/category/product-filters/FilterDropdown.vue'
import type { ProductFilter } from '~/types/productFilter'

const props = defineProps({
  filter: {
    type: Object as () => ProductFilter,
    required: true
  }
})
const searchQuery = ref('')
const isSearchable = computed(() => props.filter?.searchable)
const customRefine = (refine: any, value: any) => {
  refine(value)
  searchQuery.value = ''
}
const sortBy = computed(() => isSearchable.value ? ['isRefined', 'name'] : ['name']) as any
const { parseSwatchColor } = useSwatch()
const getName = (item: any) => parseSwatchColor(item.value)['name']
const getStyle = (item: any) => parseSwatchColor(item.value)['style']
const getSelectedItems = (items: any[]) => items ? items.filter((item: any) => item.isRefined).map((item: any) => ({ name: getName(item), style: getStyle(item) })) : []
</script>
